import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { AuthProvider } from './lib/auth';
import './index.css';

/*
  Every deploy renames the hashed chunks. A tab that loaded the site before the
  deploy still asks for the old names, gets 404s, and the lazy import fails —
  which used to leave a blank page until someone refreshed. Vite reports that
  failure as this event; a reload picks up the new index.html and the right
  chunks. Guarded so a genuinely broken build cannot reload forever: one
  reload per minute, after which the error boundary below takes over.
*/
const RELOADED_AT = 'fttmy.reloaded-for-chunk';
window.addEventListener('vite:preloadError', (event) => {
  let recently = false;
  try {
    recently = Date.now() - Number(sessionStorage.getItem(RELOADED_AT) ?? 0) < 60_000;
    sessionStorage.setItem(RELOADED_AT, String(Date.now()));
  } catch {
    // Storage unavailable: still worth one attempt.
  }
  if (recently) return;
  event.preventDefault();
  window.location.reload();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
